import { FuelButton, FuelCallout, FuelDivider, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import useGeneralInfoEvents from 'hooks/events/useGeneralInfoEvents';
import { useCopyToClipboard } from 'hooks/useCopyToClipboard';
import { useDeviceSize } from 'hooks/useDeviceSize';
import { IPix, ITruckerProfileProps } from 'interfaces/profile.interface';
import React, { FC } from 'react';
import { getAccountTextToCopyToClipboard } from 'utils/getAccountTextToCopyToClipboard';

const Banking: FC<{ data: ITruckerProfileProps }> = ({ data }) => {
  const { isMobile } = useDeviceSize();

  const [handleCopy] = useCopyToClipboard('Dados da conta');
  const { bankInfoCopiedEvent } = useGeneralInfoEvents();

  const hasBankInfo = data?.trucker?.bank?.account && data?.trucker?.bank?.number;

  const getPix = () => data?.trucker?.bank?.pix?.find((pix: IPix) => pix.status === 'active');

  const copyBankInfo = () => {
    const accountText = getAccountTextToCopyToClipboard(
      data.trucker.bank,
      data?.trucker.name,
      data?.trucker?.bank?.account?.document,
      getPix()
    );
    /* istanbul ignore else */
    if (accountText) {
      handleCopy(accountText);
    }
  };

  const handleOnClick = () => {
    bankInfoCopiedEvent();
    copyBankInfo();
  };

  return (
    <>
      {hasBankInfo && <FuelDivider />}
      <FuelFlex defaultProps={{ flexDirection: 'column', gap: 'km4', customPadding: `${DS_TOKENS.spacing.km4} 0 0 0` }}>
        {hasBankInfo ? (
          <>
            <FuelFlex
              defaultProps={{ alignItems: 'center', justifyContent: 'space-between', gap: 'km2' }}
              smProps={{ alignItems: 'flex-start', flexDirection: 'column' }}
            >
              <FuelTypography size="body-md" color="neutral-default" weight="medium">
                Recebe na Fretebras
              </FuelTypography>
              <FuelButton
                variant="secondary"
                trailingIcon="duplicate"
                fullWidth={isMobile}
                onClick={handleOnClick}
                size="small"
              >
                Copiar dados da conta
              </FuelButton>
            </FuelFlex>
            <FuelCallout
              fullWidth
              icon="shield"
              message="Pagando na Fretebras, você está protegido do golpe do adiantamento."
            />
          </>
        ) : (
          <FuelCallout
            fullWidth
            icon="alert"
            heading="Atenção"
            message="Este motorista não recebe pela Fretebras, em caso de golpe do adiantamento, não podemos intervir!"
          />
        )}
      </FuelFlex>
    </>
  );
};

export default Banking;
